import React, { useState, useEffect } from "react";
import { Box, styled } from "@mui/material";
import { Col, Divider, Row } from "antd";
import DashboardCards from "./DashboardCard";
import { useLocation } from "react-router";
import Domain from "../domain/Domain";
import Client from "../client/Client";
import Engagement from "../engagement/Engagement";
import Workflow from "../workflow/Workflow";

import { DashboardApi } from "../../services/DashboardService";
import { useAxios } from "../../contexts/AxiosProvider";

const DashboardContainer = styled(Box)(({ openDrawer }) => ({
  marginLeft: openDrawer ? 240 : 80,
  width: openDrawer ? "calc(100% - 255px)" : "calc(100% - 90px)",
  // border: openDrawer ? "2px solid green" : "2px solid blue",
  height: "calc(100vh - 70px)",
  borderRadius: "10px",
}));

const Dashboard = ({ openDrawer }) => {
  const INITIAL_STATE = {
    domains: {
      total: "0",
      approved: "0",
      pending: "0",
      label: "Functions",
      type: "Functions",
    },
    clients: {
      total: "0",
      approved: "0",
      pending: "0",
       label: "Sub-Functions",
      type: "Clients",
    },
    engagements: {
      total: "0",
      approved: "0",
      pending: "0",
      label: "Pipelines",
      type: "Engagements",
    },
    workflows: {
      total: "0",
      approved: "0",
      pending: "0",
       label: "Workflows",
      type: "Workflows",
    },
  };

  const location = useLocation();
  const axios = useAxios();

  const UserData = {
    roles: location.state?.roles,
    isAdmin: location.state?.isAdmin,
    isAuthenticated: location.state?.isAuthenticated,
    refreshToken: location.state?.refreshToken,
    accessToken: location.state?.accessToken,
    userId: location.state?.userId,
    username: location.state?.username,
  };

  const [cardType, setCardType] = useState("Domains");
  const [dashBoardData, setDashBoardData] = useState(INITIAL_STATE);
  const [loading, setloading] = useState(false);

  const fetchData = async () => {
    switch (cardType) {
      case "Domains":
        setCardType("Domains");
        break;
      case "Clients":
        setCardType("Clients");
        break;
      case "Engagements":
        setCardType("Engagements");
        break;
      case "Workflows":
        setCardType("Workflows");
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    fetchData();
  }, [cardType]);

  const fetchDashboardDataCount = async () => {
    try {
      setloading(true);
      const data = {
        user_id: location.state?.userId,
      };
      const response = await DashboardApi.getAllDashboardData(axios, data);
      if (response.status === 200) {
        const updatedData = {
          ...response.data,
          domains: { ...response.data.domains, type: "Domains", label: "Functions" },
          clients: { ...response.data.clients, type: "Clients", label: "Sub-functions" },
          engagements: { ...response.data.engagements, type: "Engagements", label: "Pipelines" },
          workflows: { ...response.data.workflows, type: "Workflows", label: "Workflows" },
          };
    setDashBoardData(updatedData);
      }
    } catch (error) {
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    fetchDashboardDataCount();
  }, []);

  return (
    <DashboardContainer openDrawer={openDrawer}>
      <div>
        <Row gutter={16}>
          <Col
            className="gutter-row"
            span={6}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={6}
          >
            <DashboardCards
              cardType={cardType}
              setCardType={setCardType}
              data={dashBoardData.domains}
            />
          </Col>
          <Col
            className="gutter-row"
            span={6}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={6}
          >
            <DashboardCards
              cardType={cardType}
              setCardType={setCardType}
              data={dashBoardData.clients}
            />
          </Col>
          <Col
            className="gutter-row"
            span={6}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={6}
          >
            <DashboardCards
              cardType={cardType}
              setCardType={setCardType}
              data={dashBoardData.engagements}
            />
          </Col>
          <Col
            className="gutter-row"
            span={6}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={6}
          >
            <DashboardCards
              cardType={cardType}
              setCardType={setCardType}
              data={dashBoardData.workflows}
            />
          </Col>
        </Row>
      </div>
      <Divider style={{ margin: "0px 0" }} />
      <div>
        {cardType === "Domains" && (
          <Domain
            openDrawer={false}
            userData={UserData}
            domainData={{
              isSearchFilterVisible: false,
              dashboard: true,
            }}
          />
        )}
        {cardType === "Clients" && (
          <Client
            openDrawer={false}
            userData={UserData}
            clientData={{
              domain_id: "all-clients",
              isSearchFilterVisible: false,
              dashboard: true,
            }}
          />
        )}
        {cardType === "Engagements" && (
          <Engagement
            openDrawer={false}
            userData={UserData}
            engagementData={{
              client_id: "all-engagements",
              isSearchFilterVisible: false,
              dashboard: true,
            }}
          />
        )}
        {cardType === "Workflows" && (
          <Workflow
            openDrawer={false}
            userData={UserData}
            WorkflowData={{
              processType: "data-all",
              engagement_id: "all-workflows",
              isSearchFilterVisible: false,
              dashboard: true,
            }}
          />
        )}
      </div>
    </DashboardContainer>
  );
};

export default Dashboard;
